/* TF Cart Promise v1 (Tires Fast). Loaded by snippets/tf-cart-promise.liquid.
   Fills the "Arrives ..." span with a real date range: ship date (today if before cutoff on a business day,
   else next business day) plus transit min/max business days. Same rules as blocks/tf-trust.liquid. */
(function () {
  if (window.tfCartPromiseLoaded) return;
  window.tfCartPromiseLoaded = true;

  function merchantNow(timezone) {
    var now = new Date();
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: timezone, year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric', hour12: false }).formatToParts(now);
      var o = {};
      for (var i = 0; i < parts.length; i++) { if (parts[i].type !== 'literal') o[parts[i].type] = parseInt(parts[i].value, 10); }
      if (o.hour === 24) o.hour = 0;
      return new Date(o.year, o.month - 1, o.day, o.hour, o.minute, o.second);
    } catch (e) { return now; }
  }
  function fmt(d) {
    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return days[d.getDay()] + ', ' + months[d.getMonth()] + ' ' + d.getDate();
  }

  function render(root) {
    var out = root.querySelector('[data-tf-cart-arrive]');
    if (!out) return;
    var cutoffHour = parseInt(root.dataset.cutoffHour, 10); if (isNaN(cutoffHour)) cutoffHour = 14;
    var timezone = root.dataset.timezone || 'America/New_York';
    var businessDays = (root.dataset.businessDays || '1,2,3,4,5').split(',').map(function (d) { return parseInt(d, 10); });
    var tMin = parseInt(root.dataset.transitMin, 10); if (isNaN(tMin)) tMin = 2;
    var tMax = parseInt(root.dataset.transitMax, 10); if (isNaN(tMax)) tMax = 5;
    function isBiz(d) { return businessDays.indexOf(d.getDay()) !== -1; }
    function addBiz(from, n) { var d = new Date(from); d.setHours(0, 0, 0, 0); while (n > 0) { d.setDate(d.getDate() + 1); if (isBiz(d)) n--; } return d; }
    var now = merchantNow(timezone);
    var cutoff = new Date(now); cutoff.setHours(cutoffHour, 0, 0, 0);
    var ship = (isBiz(now) && now < cutoff) ? new Date(now) : addBiz(now, 1);
    out.textContent = 'Arrives ' + fmt(addBiz(ship, tMin)) + ' to ' + fmt(addBiz(ship, tMax));
    root.dataset.tfRendered = '1';
  }

  function renderAll() {
    var roots = document.querySelectorAll('[data-tf-cart-promise]:not([data-tf-rendered="1"])');
    for (var i = 0; i < roots.length; i++) render(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', renderAll);
  else renderAll();
  if (typeof MutationObserver !== 'undefined') {
    new MutationObserver(renderAll).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('shopify:section:load', renderAll);
  setInterval(function () {
    var roots = document.querySelectorAll('[data-tf-cart-promise]');
    for (var i = 0; i < roots.length; i++) render(roots[i]);
  }, 60000);
})();